import { ip } from 'src/app/constant/constant';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditgamemasterdetailComponent } from './editgamemasterdetail/editgamemasterdetail.component';
import { CommonuploadimagemodelComponent } from '../shared/commonuploadimagemodel/commonuploadimagemodel.component';
import { InvitationModalComponent } from '../active-games/invitation-modal/invitation-modal.component';
import { DeleteGameAndCharacterModalComponent } from './delete-character-modal/delete-character-modal.component';
import { UploadpartytokenComponent } from '../active-games/uploadpartytoken/uploadpartytoken.component';
import { GameDetailsModalComponent } from '../active-games/game-details-modal/game-details-modal.component';
import { MapService } from 'src/app/services/map.service';
import { ConfirmModalComponent } from 'src/app/modal/confirm-modal/confirm-modal.component';
import { ToastService } from 'src/app/services/toast.service';
import { layerlist } from 'src/app/constant/maplayers';
import { GameDetailsById } from 'src/app/models/game-details.model';

@Component({
    selector: 'app-game-master-detail',
    templateUrl: './game-master-detail.component.html',
    styleUrls: ['./game-master-detail.component.scss'],
    standalone: false
})
export class GameMasterDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  acceptedChar_details: any;
  rejectedCharDetails: any;
  pendingInvitation: any;
  listofRemoveCharacters: any = [];
  game_details: GameDetailsById;
  game_id: any;
  gamedata: any;
  imageurl = ip;
  character_id: any;
  currentDate: string;
  map_id: any;
  isClassAdded = false;
  activePath: string;
  @ViewChild('map', { read: ElementRef, static: true }) mapElement: ElementRef
  isCityCode: boolean = false;
  @ViewChild('cityMap', { read: ElementRef, static: true }) cityMapElement: ElementRef
  cityCode: any
  selectedPendingInvitationMails: string[] = [];
  newLayers: any[] = []
  layerlist: any[] = layerlist
  sending: boolean = false;
  /** First load still on its way: placeholders instead of empty lists. */
  loading = true;
  loadError = false;
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataserv: DataService,
    private router: Router,
    private mapService: MapService,
    private toasterService: ToastService,
    private cdr: ChangeDetectorRef,
  ) { this.isClassAdded = true; }
  /** Seats taken by a character (the rest are open). */
  get seatedCount(): number {
    return (this.acceptedChar_details || []).filter((c: any) => c.character_id).length;
  }

  ngOnDestroy(): void {
    this.mapService.removeOldMap();
    this.mapService.removeCityLayer();

  }
  ngAfterViewInit(): void {
    this.mapService.removeOldMap();
    this.mapService.map.setTarget(this.mapElement.nativeElement);
    this.gamedetailbygameid(this.game_id);

  }



  ngOnInit(): void {
    this.activePath = localStorage.getItem('activePath');
    this.game_id = this.route.snapshot.paramMap.get('game_id');

  }

  gamedetailbygameid(game_id: number) {
    this.dataserv.gamedetailby_game_id(game_id).subscribe({ next: (res: any) => {
      this.loading = false;
      this.loadError = false;
      this.game_details = res.game_details;
      this.acceptedChar_details = res.active_characters || [];
      this.listofRemoveCharacters = [];
      this.selectedPendingInvitationMails = [];
      this.mapService.loadlayers({ map_id: this.game_details.map_id, type: 'Master', isFitExtent: true });
      this.mapService.unbindSingleClick();

      if (this.game_details.last_map_location) {
        setTimeout(() => {
          this.mapService.addSingleStaticPoint(this.game_details.last_map_location?.split(',')?.map((item: any) => (Number(item.trim()))));
        }, 0);
      }
      else {
        if (this.game_details.initial_party_location) {
          setTimeout(() => {
            this.mapService.addSingleStaticPoint(this.game_details.initial_party_location?.split(',')?.map((item: any) => (Number(item.trim()))));
          }, 0);
        }
      }
      if (this.game_details.spawn_city) {
        this.isCityCode = true;
        this.cityCode = parseInt(this.game_details.spawn_city);
        this.mapService.map1?.setTarget(this.cityMapElement.nativeElement);
        this.mapService.navigateToCityFlag = false;
        this.mapService.userProfileUrl = this.game_details.partytoken;
        this.mapService.citydataload(
          this.cityCode,
          this.game_details.map_id,
          false,
          false,
          true,
          this.game_id,
          false,
          false,
          this.game_details
        );
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
      // Push placeholder objects if the array length is less than 8
      while (this.acceptedChar_details.length < 8) {
        this.acceptedChar_details.push({ user_name: '#OPEN' });
      }

      this.rejectedCharDetails = res.rejected_requests || [];
      this.pendingInvitation = res.pending_requests || [];
      this.cdr.detectChanges();
    }, error: () => {
      this.loading = false;
      this.loadError = !this.game_details;
      this.cdr.detectChanges();
    } });
  }


  goBack() {
    this.router.navigate(['/activegames']);
  }

  openInviteModal(game_details) {
    const modalRef = this.modalService.open(InvitationModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.game_id = game_details.id;
    modalRef.componentInstance.map_id = game_details.map_id;
    modalRef.componentInstance.game_details = game_details;
    modalRef.result.then((res) => {
      if (res) {
        this.gamedetailbygameid(game_details.id);
      }
    
          this.cdr.detectChanges();})
  }

  openCharacterDeleteConfirmModal(isAllDisband: boolean) {
    const deletemodalRef = this.modalService.open(
      DeleteGameAndCharacterModalComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      }
    );
    deletemodalRef.componentInstance.game_id = this.game_id;
    deletemodalRef.componentInstance.character_ids = this.listofRemoveCharacters;
    deletemodalRef.componentInstance.isAllDisband = isAllDisband;

    deletemodalRef.result.then((res) => {
      if (res) {
        if (isAllDisband) {
          this.router.navigate(['/activegames']);
        } else {
          this.gamedetailbygameid(this.game_id);
        }
      }
    
          this.cdr.detectChanges();})
  }

  onCheckboxChange(event: any, email: string) {
    if (event.target.checked) {
      if (!this.selectedPendingInvitationMails.includes(email)) {
        this.selectedPendingInvitationMails.push(email);
      }
    } else {
      this.selectedPendingInvitationMails = this.selectedPendingInvitationMails.filter(e => e !== email);
    }
  }


  openUninviteModal(event, game_details) {
    event.stopPropagation();
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.title = 'Please Confirm';
    modalRef.componentInstance.message = 'Do you want to uninvite the selected players?';
    modalRef.componentInstance.confirmLabel = 'Yes, Uninvite';
    modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close(true));
    modalRef.result.then((res) => {
      if (res) {

        this.uninviteUsers(game_details);
      }
    
          this.cdr.detectChanges();})
  }

  uninviteUsers(game_details) {
    this.dataserv.uninviteUsers(game_details.id, this.selectedPendingInvitationMails).subscribe((res: any) => {
      if (res) {
        this.toasterService.showSuccess(res.message || 'Users Uninvited', 'success');
        this.gamedetailbygameid(game_details.id);
      }
    
          this.cdr.detectChanges();});
  }

  uploadPartyToken(data: any) {

    const modalRef = this.modalService.open(UploadpartytokenComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.masterUpdate = data.id;
    modalRef.result.then((res) => {
      if (res) {
        this.gamedetailbygameid(this.game_id);
      }
    
          this.cdr.detectChanges();});
  }

  imguploadopenmodel(data: any) {
    const editmodalRef = this.modalService.open(
      CommonuploadimagemodelComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      }
    );
    editmodalRef.componentInstance.gameDetailUpdate = data.id;
    editmodalRef.componentInstance.selectedImage = ip + data.image;

    editmodalRef.result.then((res) => {
      if (res) {
        this.gamedetailbygameid(this.game_id);
      }
    
          this.cdr.detectChanges();});
  }

  gamedetailedit(data: any) {
    const editmodalRef = this.modalService.open(EditgamemasterdetailComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    ;
    editmodalRef.componentInstance.game_id = data[0].id;
    editmodalRef.componentInstance.Gamename = data[0].Gamename;
    editmodalRef.componentInstance.Nextgame = data[0].Nextgame;

    editmodalRef.componentInstance.updateData.subscribe((res) => {
      if (res) {
        this.gamedetailbygameid(this.game_id);
      }
    
          this.cdr.detectChanges();});
  }

  playgame(gamedetail: any, activePlayers: any) {

    this.map_id = gamedetail.map_id;
    const today = new Date();
    this.currentDate = today.toISOString().slice(0, 10);
    const modalRef = this.modalService.open(GameDetailsModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.map_id = gamedetail.map_id;
    modalRef.componentInstance.game_id = gamedetail.id;
    modalRef.componentInstance.partyTokenUrl = gamedetail.partytoken;

    modalRef.componentInstance.activeCharacters = activePlayers
    modalRef.componentInstance.game_details = gamedetail
  }



  onPlayerRemoveTick(character) {
    const index = this.listofRemoveCharacters.findIndex(id => id === character.character_id);

    if (index !== -1) {
      // Remove the character if it exists
      this.listofRemoveCharacters.splice(index, 1);
    } else {
      // Add the character if it doesn't exist
      this.listofRemoveCharacters.push(character.character_id);
    }

  }
  changeToggleLayer(item: any) {
    // each layer toggles independently, so a bare map plus any combination of
    // overlays can be shown at once, rather than exactly one at a time
    item.checked = !item.checked;

    this.mapService.filterAndToggleLayers(this.newLayers);
  }

  filterlayers(layers) {
    this.newLayers = layers.filter((lyr) => lyr.toggle == true);
    return this.newLayers;
  }

  resendInvitation(game_details: any, selectedPendingInvitationMails: string[]) {
    this.sending = true;
    this.dataserv.resendInvitation(game_details.id, selectedPendingInvitationMails).subscribe((res: any) => {
      if (res) {
        this.sending = false;
        this.toasterService.showSuccess(res.message || 'Invitation Resent', 'success');
        this.selectedPendingInvitationMails = [];
        this.gamedetailbygameid(game_details.id);
      }
    
          this.cdr.detectChanges();}, (err) => {
      this.sending = false;
    
          this.cdr.detectChanges();});
  }
}
